export default __webpack_public_path__ + "static/media/a024-startup-4.95d8f316.svg";